import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'XChip',
  props: {
    label: {
        type: String,
        required: true
    },
    style: {
        type: Object,
        default: null
    },
    removable: {
        type: Boolean,
        default: false
    },
    id: {
        type: String,
        required: true
    }
},
  emits: ['labelClick', 'remove'],
  setup(__props, { emit }) {

const props = __props

const XChip = ref();




const labelClick = (event: any) => {
    emit('labelClick', event);
}

const remove = (event: any) => {
    const xChip = XChip.value;
    emit('remove', [event, xChip]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "XChip",
    ref: XChip,
    class: "p-chip p-component custom-chip mt-1 mr-2",
    id: __props.id,
    style: _normalizeStyle(props.style)
  }, [
    _createElementVNode("div", {
      class: "p-chip-text",
      onClick: labelClick,
      style: {"max-width":"10rem","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
    }, _toDisplayString(props.label), 1),
    (props.removable)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "p-chip-remove-icon pi pi-times-circle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (remove($event)))
        }))
      : _createCommentVNode("", true)
  ], 12, _hoisted_1))
}
}

})